import { render, staticRenderFns } from "./ManageProgramInformation.vue?vue&type=template&id=a25e3fca&scoped=true"
import script from "./ManageProgramInformation.vue?vue&type=script&lang=js"
export * from "./ManageProgramInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25e3fca",
  null
  
)

export default component.exports